<template>
  <!--悬浮小广告样式的提示信息-->
  <div
    id="thediv"
    ref="thediv"
    :style="{position: 'absolute', zIndex: '111', left:  '0', top:  '0'}"
    v-if="thedivShow"
    @mouseover="clearFdAd"
    @mouseout="starFdAd"
  >
      <div class="sildLeft">
        <div
          class="sidBoximg"
          v-for="(items,index) in colocList "
          :key="index"
          
          v-on:mouseenter="showDialog(index)"
          v-on:mouseleave="hideDialog(index)"
        >
          <img class="sidBoximgbg" :src="items.img" alt />
          <img @click="thedivShow = false" class="sidimgs" :src="colserimg" alt style="position: absolute;
            top: 0;
            right: 0;
            width: 20px;
            height: 20px;" />
        </div>
      </div>
  </div>
</template>

<script>
let interval;
export default {
  props:{
    piaocShow:{
      type:Boolean,
      default:true
    },
    zx:{
      type:Number,
      default:0
    },
    zy:{
      type:Number,
      default:0
    },
  },
  data() {
    return {
      xPos:0,
      yPos:0,
      xin: true,
      yin: true,
      step: 1,
      delay: 18,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,
      colserimg: require('@/assets/index/colosemr.png'),
      colocList: [
        {
          img: require('@/assets/index/oneimg.jpg'),
          colserimg: require('@/assets/index/colosemr.png'),
        },
      ],
    };
  },

  mounted() {
    if(this.piaocShow){
      if(this.zx){
        this.xPos=this.zx
      }
      if(this.zy){
        this.yPos=this.zy
      }
      interval = setInterval(this.changePos, this.delay);
    }else{
      clearInterval(interval)
    }
    
  },
 

  methods: {
    showDialog(index) {
      this.colserimg = require('@/assets/index/coloract.png');
    },
    hideDialog(index) {
      this.colserimg = require('@/assets/index/colosemr.png');
    },
    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
      this.Woffset = this.$refs.thediv.offsetWidth;

      // 滚动部分跟随屏幕滚动
      this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
      this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

      // 滚动部分不随屏幕滚动
      // this.$refs.thediv.style.left =
      //   this.xPos + document.body.scrollLeft + "px";
      // this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

      if (this.yon) {
        this.yPos = this.yPos + this.step;
      } else {
        this.yPos = this.yPos - this.step;
      }
      if (this.yPos < 0) {
        this.yon = 1;
        this.yPos = 0;
      }
      if (this.yPos >= height - this.Hoffset) {
        this.yon = 0;
        this.yPos = height - this.Hoffset;
      }

      if (this.xon) {
        this.xPos = this.xPos + this.step;
      } else {
        this.xPos = this.xPos - this.step;
      }
      if (this.xPos < 0) {
        this.xon = 1;
        this.xPos = 0;
      }
      if (this.xPos >= width - this.Woffset) {
        this.xon = 0;
        this.xPos = width - this.Woffset;
      }
    },
    clearFdAd() {
      clearInterval(interval);
    },
    starFdAd() {
      interval = setInterval(this.changePos, this.delay);
    },
  },
};
</script>

<style lang="scss" scoped>
#thediv {
  z-index: 100;
  position: absolute;
  top: 43px;
  left: 2px;
  // height: 184px;
  width: 200px;
  overflow: hidden;
  img{
      width: 100%;
      height: 100%;
  }
}
.sidimgs {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
}

</style>
